"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fp = require("lodash/fp");
var getFulfillmentCondition = function getFulfillmentCondition(fulfilledAfterDays) {
  return fulfilledAfterDays && (0, _fp.isNumber)(fulfilledAfterDays) && fulfilledAfterDays > 0 ? [{
    value: " after "
  }, {
    value: "".concat(fulfilledAfterDays)
  }, {
    value: ' days'
  }] : [];
};
var _default = exports["default"] = getFulfillmentCondition;
module.exports = exports.default;